export { default as FourOhFourError } from './FourOhFourError';
export type { FourOhFourErrorProps } from './FourOhFourError';
export { default as FourOhFourErrorPage } from './FourOhFourErrorPage';
